import ClaimCategoriesSelect from './ClaimCategoriesSelect'

export default ClaimCategoriesSelect
